module.exports = __webpack_public_path__ + "static/img/LT.27da842b.svg";